import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Header } from './Header';
import { Footer } from './Footer';
import { PageTitle } from './PageTitle';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-297">
      <PageTitle data-id="element-298" />
      <TopBar data-id="element-299" />
      <Header data-id="element-300" />
      <main className="flex-1" data-id="element-301">
        <Outlet data-id="element-302" />
      </main>
      <Footer data-id="element-303" />
    </div>;
}